import { ApprovalProject } from './types';

export type ApprovalState = {
  loading: boolean;
  error: string;
  projects: ApprovalProject[];
  selectedProjectId: string;
};

export const initialState: ApprovalState = {
  loading: false,
  error: null,
  projects: [],
  selectedProjectId: null,
};
